/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  
  
==========================================================================================*/


const mutations = {

  setStudent (state, payload) {
    state.student = payload
  },
  setDeletedUser (state, payload) {
    state.deletedUser = payload
  },
  setRegisterUserEmail (state, payload) {
    state.emailRegisteredUser = payload
  },
  setNewsletterJson (state, payload) {
    state.newsletter_json = payload
  },
  setResizeWidth (state, payload) {
    state.resize_width = payload
  },
  setResizeImgs (state, payload) {
    state.resize_imgs = payload
  },
  setCompleteImg (state, payload) {
    state.complete_resize_img = payload
  },
  setStartImg (state, payload) {
    state.start_resize_img = payload
  },
  setBuilderMenu (state, payload) {
    state.builder_menu = payload
  },


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON (state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE (state, val) {
    state.mainLayoutType = val
  },
  UPDATE_NAV_BAR_COLOR (state, val) {
    state.navbarcolor = val
  },

  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE (state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED (state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE (state, list) {
    let downToUp                 = false
    const lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY (state, val) {
    state.bodyOverlay = val
  },
  UPDATE_PRIMARY_COLOR (state, val) {
    state.themePrimaryColor = val
  },
  UPDATE_THEME (state, val) {
    state.theme = val
  },
  UPDATE_APP_TITLE (state, val) {
    state.themeTitle = val
  },
  UPDATE_APP_TOP_BAR_TITLE (state, val) {
    state.topBarTitle = val
  },
  UPDATE_APP_LOGO (state, val) {
    state.themeLogo = val
  },
  UPDATE_WINDOW_WIDTH (state, width) {
    state.windowWidth = width
  },
  UPDATE_WINDOW_SCROLL_Y (state, val) {
    state.scrollY = val
  },
  UPDATE_LOGIN_PAGE_IMAGE (state, val) {
    state.loginPageImage = val
  },
  UPDATE_APP_SHOW_LOGIN_IMG (state, val) {
    state.showLoginImg = val
  },
  UPDATE_APP_TOPBAR_MESSAGE_COUNTER (state, val) {
    state.topbarMessageCounter = val
  },

  UPDATE_APP_CURRENT_LOCATION (state, val) {
    state.currentLocation = val
    localStorage.setItem('currentLocation', JSON.stringify(val))
  },
  UPDATE_APP_CURRENT_LOCATION_DROPDOWN (state, val) {
    state.currentLocationDropdown = val
  },
 
  UPDATE_TEACHER_MESSAGE_COUNT (state, val) {
    state.teacherMessageCount = val
  },
  UPDATE_APP_ACTIVITY_PROGRAM_DROPDOWN (state, val) {
    state.activitiesAppProgramDropdown = val
  },
  UPDATE_APP_ACTIVITY_PROGRAM_STUDENT_DROPDOWN (state, val) {
    state.activitiesAppProgramStudentDropdown = val
  },
  UPDATE_APP_CURRENT_ACTIVITY_ROOM (state, val) {
    state.currentAppActivityRoom = val
  },
  UPDATE_STUDENT_ACCOUNT_DETAILS (state, val) {
    state.currentStudentAccountDetails = val
  },
  UPDATE_CURRENT_LOCATION_PENDING_USER (state, val) {
    state.currentLocationPendingUser = val
  },
  UPDATE_CURRENT_LOCATION_STATIC_CARD (state, val) {
    state.currentLocationStaticCard = val
  },
  UPDATE_AGENCY_ACCOUNT_DETAILS (state, val) {
    state.currentAgencyAccountDetails = val
  },
  UPDATE_AGENCY_STUDENTS (state, val) {
    state.currentAgencyStudents = val
  },
  UPDATE_SETUP_FORM_STEPS (state, val) {
    state.setupFormSteps = val
  },
  
  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO (state, payload) {

    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] != null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  UPDATE_APP_SCHOOL_NAME (state, val) {
    state.schoolTitle = val
  },
  UPDATE_APP_CAMERA_LOGIN_FEATURE (state, val) {
    state.schoolCameraLoginFeature = val
  },
  SHOW_TOP_NAVBAR (state, val) {
    state.showTopNavbar = val
  },
  UPDATE_BUCKET_INFO (state, val) {
    state.bucketInfo = val
  },
  ENABLE_CAMERA_MODULE (state, val) {
    state.cameraModule = val
  },
  SHOW_PARENT_DIRECTORY (state, val) {
    state.showParentDirectory = val
  },
  SHARE_CUSTOM_NEWSLETTER (state, val) {
    state.shareCustomNewsletter = val
  },
  ACTIVE_AVATAR_UPLOAD (state, val) {
    state.avatarUpload = val
  },
  UPDATE_LEARNING_SIDEBAR_TOGGLE (state, val) {
    state.learningSidebar = val
  },
  UPDATE_ONLINE_USERS (state, val) {
    state.onlineUsers = val
  },
  UPDATE_FILE_MESSAGES (state, val) {
    state.fileMessages = val
  },
  UPDATE_BLOG_DATA (state, val) {
    state.loadBlogData = val
  },
  HANDLE_PORTFOLIO_BACK (state, val) {
    state.isPortfolioPage = val
  }
  
  
}
export default mutations

